import { render, staticRenderFns } from "./sopartlackmateril.vue?vue&type=template&id=6273a56b&scoped=true&"
import script from "./sopartlackmateril.vue?vue&type=script&lang=js&"
export * from "./sopartlackmateril.vue?vue&type=script&lang=js&"
import style0 from "./sopartlackmateril.vue?vue&type=style&index=0&id=6273a56b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6273a56b",
  null
  
)

export default component.exports